// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.about[data-v-cad05094] {\n    background: url('https://enercred.com.br/wp-content/themes/enercred-1/assets/min-images/servico/mockup-celular.png') center center no-repeat;\n    background-size: cover;\n    min-height: 100vh;\n    width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
